import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Heart, Sparkles } from "lucide-react";
import Typewriter from "../components/Typewriter";
import { useMusic } from "../context/MusicContext";

const Home = ({ onBeginJourney }) => {
  const { startMusic } = useMusic();

  const handleBeginJourney = () => {
    startMusic();
    onBeginJourney();
  };

  return (
    <section className="flex flex-col items-center justify-center text-center py-24 px-4 min-h-screen">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8 }}
        className="mb-8"
      >
        <Sparkles className="w-24 h-24 text-yellow-400 animate-spin-slow" />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl md:text-7xl font-dancing text-rose-600 mb-4"
      >
        Happy Love Anniversary
      </motion.h1>

      <Typewriter
        text="Selvi & Dhanush Forever 💞"
        className="text-2xl md:text-4xl font-bold text-pink-700 mb-6"
      />

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="mt-10"
      >
        <Heart className="w-20 h-20 text-rose-600 fill-rose-600" />
      </motion.div>

      <Link
        to="/story"
        className="mt-10 bg-rose-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-rose-700 transition shadow-lg"
        onClick={handleBeginJourney}
      >
        Begin Our Journey ✨
      </Link>
    </section>
  );
};

export default Home;
